import React, { useState, useEffect } from 'react';
import { europeanCountries, TOAST_OPTIONS } from "../../constants";

//UTILS
import { useSearchParams } from 'react-router-dom';
import { isMobile } from "react-device-detect";
import { ToastContainer, toast } from 'react-toastify';
import UserService from '../../services/user_services';

//COMPONENTS
import FollowUp from "../../components/followup";
import Header from "../../components/header";
import Button from "../../components/button";
import { ThreeDots } from "react-loader-spinner";

//VISUALS
import BANNER_VISUAL from "../../assets/images/girl_back_lifise.jpg";
import LOGO_WHITE from "../../assets/images/full_white.png";

//TRANSLATION
import { useTranslation } from 'react-i18next';

const SignUp = ({ magic }) => {
    const { t } = useTranslation();
    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams();
    const [email, onChangeEmail] = useState();
    const [firstname, onChangeFirstname] = useState(null);
    const [lastname, onChangeLastname] = useState(null);
    const [countryCode, onChangeCountryCode] = useState('33');
    const [phoneNumber, onChangePhoneNumber] = useState(null);
    const [success, onChangeSuccess] = useState(false);
    const [did, onChangeDid] = useState(null);
    const [twoFAToken, onChangeTwoFAToken] = useState(null);
    const [loading, onChangeLoading] = useState(false);
    const [checkEurope, toggleEuropeCheck] = useState(false);
    const [checkTerms, toggleTermsCheck] = useState(false);
    const [uuuid, setUuuid] = useState(null);

    const handleCountryChange = (e) => {
        const selectedCode = e.target.value;
        onChangeCountryCode(selectedCode);
    };

    const homeRedirect = () => window.location.href = "/";

    const magicSignUp = async () => {
        // eslint-disable-next-line
        let re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
        if (!email || !re.test(email)) {
            toast.error(t('signup.error_email'), TOAST_OPTIONS);
        } else if (!countryCode || !phoneNumber) {
            toast.error(t('signup.set_phone'), TOAST_OPTIONS);
        } else if (!firstname) {
            toast.error(t('signup.set_firstname'), TOAST_OPTIONS);
        } else if (!lastname) {
            toast.error(t('signup.set_lastname'), TOAST_OPTIONS);
        } else if (!checkEurope) {
            toast.error(t('signup.validate_citizenship'), TOAST_OPTIONS);
        } else if (!checkTerms) {
            toast.error(t('signup.agree_cgu'), TOAST_OPTIONS);
        } else {
            try {
                onChangeLoading(true);
                const didToken = await magic.auth.loginWithEmailOTP({ email });
                onChangeDid(didToken);
                const phone = `+${countryCode}${phoneNumber}`;
                const resp = await UserService.register(firstname, lastname, email, phone, didToken, uuuid);
                console.log(resp);
                if (resp.status) {
                    onChangeSuccess(true);
                    onChangeLoading(false);
                }
                else {
                    toast.error(t(resp.message), TOAST_OPTIONS);
                    onChangeLoading(false);
                }
            } catch (e) {
                console.log(e);
                toast.error(e.response && e.response.data ? t(e.response.data.message) : t(e.message), TOAST_OPTIONS);
                onChangeLoading(false);
            }
        }
    }

    const loginTwoFA = async () => {
        if (!twoFAToken) {
            toast.error(t('signup.set_code'), TOAST_OPTIONS);
        } else {
            try {
                onChangeLoading(true);
                const resp = await UserService.twofaLogin(twoFAToken, did);
                if (resp.status) {
                    window.location.href = "/dashboard"
                }
                else {
                    toast.error(t(resp.message), TOAST_OPTIONS);
                    onChangeLoading(false);
                    onChangeSuccess(false);
                    window.location.href = "/signin"
                }
            } catch (e) {
                console.log(e);
                toast.error(uuuid ? `${t('signup.could_not_open')} ${email}` : e.response && e.response.data ? t(e.response.data.message) : t(e.message), TOAST_OPTIONS);
                onChangeLoading(false);
                onChangeSuccess(false);
                onChangeTwoFAToken(null);
                window.location.href = "/signin"
            }
        }
    }

    const checkInvit = () => {
        setUuuid(searchParams.get("user_uuid"))
    }

    useEffect(() => {
        checkInvit();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            {isMobile && <Header />}
            <div className="container mt-0">
                <div className="left_sign" style={{ backgroundImage: `url('${BANNER_VISUAL}')` }}>
                    <img src={LOGO_WHITE} alt="Lifise logo" className="logo" onClick={homeRedirect} />
                </div>
                <div className="right_sign">
                    <p className="instructions">{t('signup.fill_required_info')}</p>
                    <h1>{t('signup.open_account')}</h1>
                    {success ?
                        <React.Fragment>
                            <div>
                                <label className="ml-0">{t('signup.fatoken')}</label>
                                <input
                                    type="number"
                                    className="semi mt-10"
                                    placeholder={t('signup.code')}
                                    onChange={e => onChangeTwoFAToken(e.target.value)}
                                    name="twofa-code"
                                    maxLength="6"
                                />
                            </div>
                            {!loading && <>
                                <Button title={t('signup.validate_account')} click={loginTwoFA} />
                            </>}
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <div className="display-inline-block mr-20 mt-0">
                                <label>{t('signup.firstname')}</label>
                                <input
                                    type="text"
                                    className="semi"
                                    placeholder={t('signup.firstname')}
                                    onChange={e => onChangeFirstname(e.target.value)}
                                    name="firstname"
                                />
                            </div>
                            <div className="display-inline-block mt-0">
                                <label>{t('signup.lastname')}</label>
                                <input
                                    type="text"
                                    className="semi"
                                    placeholder={t('signup.lastname')}
                                    onChange={e => onChangeLastname(e.target.value)}
                                    name="lastname"
                                />
                            </div>
                            <label>{t('signup.email')}</label>
                            <input
                                type="email"
                                placeholder={t('signup.email')}
                                onChange={e => onChangeEmail(e.target.value)}
                                name="email"
                            />
                            <div className="display-inline-block mr-20 mt-0">
                                <label>{t('signup.country')}</label>
                                <select className="semi" onChange={handleCountryChange} value={countryCode || '33'}>
                                    {europeanCountries.map((country) => (
                                        <option key={country.code} value={country.code}>
                                            {country.name} (+{country.code})
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="display-inline-block mt-0">
                                <label>{t('signup.phone_number')}</label>
                                <input
                                    type="tel"
                                    className="semi"
                                    placeholder="123456789"
                                    onChange={e => onChangePhoneNumber(e.target.value)}
                                    name="phone"
                                />
                            </div>
                            <label className="ml-0">
                                <input type="checkbox" onClick={() => toggleEuropeCheck(!checkEurope)} /> {t('signup.declare_citizenship')}
                            </label>
                            <label className="ml-0">
                                <input type="checkbox" onClick={() => toggleTermsCheck(!checkTerms)} /> {t('signup.i_agree')} <a href={"https://www.lifise.io/fr/mentions-legales"} target="_blank" rel="noreferrer">{t('signup.cgu')}</a>
                            </label>
                            {!loading &&
                                <>
                                    <Button title={t('signup.create_account')} click={magicSignUp} /> <FollowUp intro={t('signup.already_user')} description={t('signup.sign_now')} link={"/signin"} />
                                </>}
                        </React.Fragment>}
                    <ThreeDots visible={loading} height="50" width="50" color="#1F90FA" radius="9" ariaLabel="three-dots-loading" />
                </div>
            </div>
            <ToastContainer />
        </>
    )
};

export default SignUp;